import React, {useState, useEffect} from 'react'
import {LoadEffect}  from '../component/loader'
import axios from 'axios'
import { Alerts} from '../component/notify'
import PageHeader from '../component/pageheader'
import {classID,  sectionID, ServerUrl,  userCode,  Token, config, ImagesUrl, API_URL} from '../../component/include'

import {  longDate, FormatNumber, getClassName} from '../component/globalFunction'
import { userToken } from '../component/authentication'

const DisplayStudentAttendance =()=> {


    const [summary, setSummary] = useState([])
    const [CurrentSession, setCurrentSession] = useState('')
    const [errors, setErrors] = useState({});
    const [result, setResult] = useState([])
    const [sqlQuery, setSqlQuery] = useState([]);
    const [subject, setSubject]= useState([])
    const [schoolInfo, setSchoolInfo]=useState([])
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 
    
    const [head, setHead]= useState([])
    const [schoolClass, setSchoolClass]=useState([]);
    const [attendance, setAttendance] = useState({
        subject:[],
        attendanceType:'fullday',
        attendanceMonth:'',
    })
    const  handleSession =()=>{

        var sql ="Select  startYear from tbl_school_session where status ='Active'"
        const fd = new FormData();
        fd.append("sql", sql);
        let url = API_URL+'/exam/result/fetch_raw'  
        axios.post(url, fd, config)
        .then(result => {
            if(result.data.data.length!==0){
            setCurrentSession(result.data.data[0].startYear)
            
        }
        })
        .catch((error)=>{
            Alerts('Error!', 'danger', JSON.stringify(error.message)) 
        })
        }
    const fetchSchoolInfo =()=>{
        let url = API_URL + '/fetch/data/tbl_basic_details'
    axios.get(url, config).then(result=>setSchoolInfo(result.data.data))

    }

    const  handleFetchClass =()=>{
       
            let url = API_URL+'/fetchfield/tbl_school_class/schoolClass/ID/1'
        axios.get(url, config)
        .then(result => setSchoolClass(result.data.data))
        .catch((error)=>Alerts('Error!', 'danger', JSON.stringify(error.message))) 
         }
       
    
        const fetchSubject =()=>{
            let url = API_URL + '/fetch/data/tbl_subject'
    axios.get(url, config).then(result=>setSubject(result.data.data))
        }

        
       

        const handleChange=(event)=>{
            const {name, value} = event.target;
            setAttendance({...attendance, [name]:value})

            if(name==='attendanceMonth'){
            const days =  new Date(value.slice(0,4), value.slice(5,7), 0).getDate();
            const start = value+'-01';
            const end = value+'-'+days;
            getDaysBetween(start, end)
            }
            setResult('')
            setErrors({...errors, [name]:''})
        }
       
      
      
        const getDaysBetween =(startDate, endDate)=>{
            const start = new Date(startDate)
            const end =  new Date(endDate)
        
            var result = []
            while (start <= end){
                result.push(new Date(start).toISOString().slice(0,10))
                start.setDate(start.getDate()+1)
            }
    
            let sqlString = result.map(data=>"max(case when a.attendanceDate  = '"+data+"'  then a.indicator else '-' end) AS '"+data.slice(8,10)+getDays(data)+"'")
            setHead(result.map(data=>data.slice(8,10)+getDays(data)))
    
            let final =  'SELECT  s.admissionNumber, s.studentName, sum(case when a.indicator  = "P" then 2 else 0 end) as P, sum(case when a.indicator  = "H" then 1 else 0 end) as H, sum(case when a.indicator  = "A" then 2 else 0 end) as A, '+String(sqlString)+ ' from tbl_students s, tbl_student_attendance a where   s.code = a.studentCode and a.attendanceDate >= "'+startDate+'" and a.attendanceDate <= "'+endDate+'" and a.studentCode = "'+userCode+'"'


            setSqlQuery(final)
        }

        const getDays=(date)=>{
            let day;
            switch (new Date(date).getDay()){
                case 0:
                    day =" Sun";
                    break;
                case 1:
                    day =" Mon";
                    break;
                case 2:
                    day =" Tue";
                   break;
                case 3:
                    day =" Wed";
                        break;
                case 4:
                    day =" Thu";
                        break;
                case 5:
                    day =" Fri";
                    break;
                case 6:
                    day =" Sat"
                    break;
                default:
                    day=" Sun"
            }
                return day
            }
    
            const fetchResult =()=>{
                 if(attendance.attendanceMonth===''){
                    setErrors({...errors, attendanceMonth:'Please select attendnace month'})
                }else{
                    
                
                    fetchSummary(CurrentSession)
                    var sql = sqlQuery

            

            sql = sql+ ' group by a.studentCode '
            
            
  setNotice({...notice, isLoading: true}) 
  const fd = new FormData();
            fd.append("sql", sql);
            let url = API_URL+'/exam/result/fetch_raw'  
            axios.post(url, fd, config).then(result=>{
                if(result.data.data.length!==0){
                    setResult(result.data.data)
                    window.scrollTo(0, document.body.scrollHeight)
                }else{
                    Alerts('Message!', 'info', 'There were no attendance for this month')
                }
                
            })
            .catch((error)=>{
            Alerts('Error!', 'danger', error.message)
            }).finally(()=>{
                setNotice({...notice, isLoading: false})
                
            })  
        } 
            }
    
     

      
        
     const fetchSummary =(current)=>{
        let sql =   'SELECT  s.admissionNumber, s.studentName, sum(case when a.indicator  = "P" then 2 else 0 end) as P, sum(case when a.indicator  = "H" then 1 else 0 end) as H, sum(case when a.indicator  = "A" then 2 else 0 end) as A from tbl_students s, tbl_student_attendance a where s.code = a.studentCode  and a.studentCode = "'+userCode+'" and a.sessionYear = "'+current+'" and a.sectionID = "'+sectionID+'"  group by a.studentCode'

          setNotice({...notice, isLoading: true}) 
                const fd = new FormData();
                fd.append("sql", sql);
            
            let url = API_URL+'/exam/result/fetch_raw'  
                axios.post(url, fd, config).then(result=>{
                    if(result.data.data.length!==0){
                        setSummary(result.data.data)
                    }
                    
                })
                .catch((error)=>{
                Alerts('Error!', 'danger', error.message)
                }).finally(()=>{
                    setNotice({...notice, isLoading: false})
                    
                })  
            } 

     useEffect(()=>{
         handleFetchClass()
        fetchSchoolInfo()
        fetchSubject()
        handleSession()
    },[]);


        return (  
            <React.Fragment>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Search  Attendance">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-calendar"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Attendance</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Student Attendance</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

                <div className="row  ">
						
                        <div className="col-sm-12">
                    
                        <div className="card z-depth-0">
                            <div className="card-header">
                                <h5><i className="fa fa-edit" ></i> Student Attendance</h5>
                                <div className="card-header-right">
                                    <ul className="list-unstyled card-option">
                                        <li><i className="feather icon-maximizes full-card"></i></li>
                                        <li><i className="feather icon-minus minimize-card"></i></li>
                                        <li><i className="feather icon-trash-2 close-card"></i></li>
                                    </ul>
                                </div>
                            </div>
                            
                            
                            <div className="card-block">
            
        <section className="col-md-12">
        <span className="pcoded-badge label bg-simple-c-pink">Color Icon For Absent</span>
        
        <span className="pcoded-badge label label-info">Color Icon For Half Day</span>
        <span className="pcoded-badge label bg-simple-c-green">Color Icon For Present</span>
        </section>


        <div  className="card-block">
        <div  className="card z-depth-0" >

		<div  className="card-block">
		
        <div className="row">
      
      <section className="col-md-6">
      <div className="form-group">
   <label >Attendance Month (yyyy-mm)</label>
   <input type="month" className={errors.attendanceMonth ? 'form-control form-control-danger' : 'form-control'} name="attendanceMonth"   onChange={handleChange} value={attendance.attendanceMonth} />

   <span style={{color:'red'}}>{errors.attendanceMonth && errors.attendanceMonth}</span>
               </div>

   

</section>
{/* 
<section className="col-md-6">
<div className="form-group">
                    <label >Type</label>
                    
                    <div className="form-radio">
                <div className="radio radio-inline"><label>
						<input type="radio" checked={attendance.attendanceType ==="fullday"} onChange={handleChange} value="fullday" name="attendanceType" />
										<i className="helper"></i>Full Day</label></div>

                                        <div className="radio radio-inline"><label>
						<input type="radio" checked={attendance.attendanceType ==="subject"} onChange={handleChange} value="subject" name="attendanceType"  />
										<i className="helper"></i>Subject Wise</label></div>

                    </div>
                    
                    </div>

</section>		
      <section className="col-md-6" style={{display:attendance.attendanceType ==="fullday"?'none':'block'}}>


      <div className="form-group">
						<label >Subject<span style={{color:'red'}}>*</span></label>
                        <Select options={
                            subject&&subject.map((list, idx)=> {
                               return {key:idx, value: list.code, label: list.subjectName, abr:list.abbreviation }
                             })} 
                             getOptionLabel={option =>`${option.label} - ${option.abr}`}
onChange={handleSelect} className={errors.subject ? 'form-control form-control-danger' : ''} name="subject" value={attendance.subject}  /> <span style={{color:'red'}}>{errors.subject && errors.subject}</span>	
			</div>
      
      </section>
 */}

<section className="col-md-6">
	<br/>
	<button type="button" id="submit" onClick={fetchResult} className="btn btn-primary "><i className="fa fa-search"></i> Search Attendance</button>		</section>		
                                </div>
                            
                            
                            </div></div> 
							</div></div>
</div>
</div>
</div>

{result.length!==0?
    <div className="card z-depth-0">
		<div className="card-block">
	
        {schoolInfo&&schoolInfo.map((st, id)=>
                       <div className="row" key={id}>

<table className="table  table-full-width">
       <tbody>
                <tr>
               {/*  <td >
                    <div className='row'>
                        <div className='col-md-3'>
                    <img id="viewSchoolLogo2"  className="img-100 pull-right" onError={(e)=>{e.target.onerror = null; e.target.src=ServerImagesUrl+'/logo.png'}} src={`${ServerImagesUrl}/about/${st.schoolLogo}`}  title="School Logo" alt=''  />
                    </div>

                    <div className='col-md-6'>
<h4 style={{textAlign:'center'}}><b>{'schoolName'}</b></h4>
<div style={{textAlign:'center'}}>  {st.address}  </div>
<div style={{textAlign:'center'}}>  {st.mobile} &nbsp; {st.altMobile} </div>
 <div style={{textAlign:'center'}}>  {st.email} </div>
 </div></div>
 </td> */}

<td className="text-center" >
                    <img id="viewSchoolLogo2"  onError={(e)=>{e.target.onerror = null; e.target.src=ImagesUrl+'/logo.png'}} src={`${ImagesUrl}/about/headerlogo.png`}   alt={'schoolName'}  />
 </td>
                </tr>
            </tbody>
       </table>

</div> 
                       )}
 <div className="row">
        <div className="col-md-12">
        <h5 style={{textAlign:'center'}}><u><b>Student Attendance </b></u></h5>
        </div></div><br/>



<div className="row">

<div className="col-md-12">

       <table className="table table-bordered  table-full-width">
       <tbody>
                <tr>
                    <td >Class: <b>{getClassName(classID, sectionID, schoolClass)}</b></td>
                    <td >Month: <b>{attendance.attendanceMonth}</b></td>
                </tr>
            </tbody>
       </table>
       
<div className=" table-responsive">
       <table className="table table-striped  table-bordered">
        <thead>
                <tr>
                <th>S/N</th>
                <th>Admission No</th>
                    <th>Student Name</th>
                   
                  
                    <th>P</th> 
                    <th>H</th>
                    <th>A</th>
                     {head&&head.map((data, id)=><th key={id} >{data}</th>)} 
                </tr>
              </thead>
              <tbody>
              {result.length!==0?result.map((st, idx)=> 
                <tr key={idx}>
                <td>{idx+1}</td>
                <td>{st.admissionNumber}</td>
                    <td>{st.studentName}</td>
                <td>{st.P}</td>
                <td>{st.H}</td> 
                    <td>{st.A}</td>            
                    {head&&head.map((data, id)=><td key={id} >
                    {st[data]==='P'?
                    <span className="pcoded-badge label label-success">{st[data]}</span>:
                    st[data]==='A'?
                    <span className="pcoded-badge label label-danger">{st[data]}</span>: 
                    st[data]==='H'?
                    <span className="pcoded-badge label label-info">{st[data]}</span>:
                    st[data]} </td>)} 
                </tr>):[]}
              </tbody>
     

        </table>
 </div>	 </div> 
 </div>




 </div>
        </div>:''}



        {summary.length!==0?


    <div className="card z-depth-0">
		<div className="card-block">
	
        {schoolInfo&&schoolInfo.map((st, id)=>
                       <div className="row" key={id}>
<table className="table  table-full-width">
       <tbody>
                <tr>
                <td className="text-center" >
                    <img id="viewSchoolLogo2"  onError={(e)=>{e.target.onerror = null; e.target.src=ImagesUrl+'/logo.png'}} src={`${ImagesUrl}/about/headerlogo.png`}   alt={'schoolName'}  />
 </td>
                </tr>
            </tbody>
       </table>

</div> 
                       )}
 <div className="row">
        <div className="col-md-12">
        <h5 style={{textAlign:'center'}}><u><b> Attendance Summary</b></u></h5>
        </div></div><br/>



<div className="row">
<div className="col-md-12 table-responsive">

       <table className="table table-bordered  table-full-width">
       <tbody>
                <tr>
                    <td >Class: <b>{getClassName(classID, sectionID, schoolClass)}</b></td>
                    <td >Session: <b>{CurrentSession}</b></td>
                    <td> Date Printed: <b>{longDate(new Date())} </b></td>
                </tr>
            </tbody>
       </table>
       <table className="table table-striped table-bordered">
        <thead>
                <tr>
                <th>Admission No</th>
                    <th>Student Name</th>
                    <th>Total Attendance</th>
                    <th>Total Present</th>
                    <th>Total Absent</th>
                    <th>Present (%)</th>
                    <th>Absent (%)</th>
                </tr>
              </thead>
              <tbody>
              {summary.length!==0?summary.map((st, idx)=> 
                <tr key={idx}>
                <td>{st.admissionNumber}</td>
                    <td>{st.studentName}</td>
                    <td>{Number(st.P) + Number(st.A)}</td>
                    <td>{st.P}</td>
                    <td>{st.A}</td>
                    <td>{FormatNumber(((100*Number(st.P)) / (Number(st.P) + Number(st.A) )))}</td>
                    
                    <td>{FormatNumber(((100*Number(st.A)) / (Number(st.P) + Number(st.A) )))}</td>
                </tr>):[]}
              </tbody>

        </table>
 </div>	 </div> 

 <div className="row">
        <div className="col-md-12">
        <form method='POST' action={ServerUrl+'/printout/student_attendance.php?token='+userToken} target='_blank'>
                <input type='hidden' name='result' value ={JSON.stringify(summary, null, 2)} />
                <input type='hidden' name='dateRange' value ={CurrentSession} />
                <input type='hidden' name='sectionID' value ={getClassName(classID, sectionID, schoolClass)} />
                <input type='hidden' name='jwtToken' value ={Token} />



        <button type="submit" className="btn btn-inverse pull-right no-print" > <i className="fa fa-print"></i> Print</button>
        
        </form>
        </div></div>

 </div>
        </div>:''}



   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</React.Fragment>
 );
        
}

export default React.memo(DisplayStudentAttendance) 